import { useContext } from 'react'

import { PopoverParentContext } from '../PopoverParent'

export function usePopoverParentRef() {
  return useContext(PopoverParentContext)
}
